import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import { scrollToWithOffset } from "../../common/utils/scrollTo";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollToWithOffset("about")}>
          <Span>{t("Product")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollToWithOffset("mission")}>
          <Span>{t("Personalized")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollToWithOffset("founders")}>
          <Span>{t("About Us")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall
          style={{ width: "150px" }}
          onClick={() => scrollToWithOffset("contact")}
        >
          <Span>
            <Button small>{t("Contact")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo.svg" width="250px" height="50px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Row style={{ marginBottom: "2.5rem", width: "100%" }} align="middle">
            {/* Empty 8 columns on the left */}
            <Col offset={0} span={8} />

            {/* Middle 8 columns (centered text) */}
            <Col span={8} style={{ textAlign: "center" }}>
              <Menu>Menu</Menu>
            </Col>

            {/* Right 8 columns (icon aligned right) */}
            <Col span={8} style={{ textAlign: "right" }}>
              <button
                onClick={toggleButton}
                style={{ background: "none", border: "none", cursor: "pointer" }}
              >
                <Outline />
              </button>
            </Col>
          </Row>

          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
